import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

/**
 * 未触发条件单
 */
@Component({
})
export default class OrderSearch extends Vue {

  @Prop()
  public tableData;

  public tableTitle: IFixedTableTitle[] = [
    {
      text: '合约',
      width: '2rem',
      name: 'targetId',
    },
    {
      text: '开平',
      width: '1.5rem',
      name: 'offset',
    },
    {
      text: '报单价格',
      width: '2rem',
      name: 'price',
    },
    {
      text: '报单手数',
      width: '2rem',
      name: 'volume',
    },
    {
      text: '未成交数',
      width: '2rem',
      name: 'unvolume',
    },
    {
      text: '报单时间',
      width: '3rem',
      name: 'insertTime',
    },
    {
      text: '报单状态',
      width: '2rem',
      name: 'state',
    },
    // {
    //   text: '报单编号',
    //   width: '2rem',
    //   name: 'orderId',
    // }
  ];
}



// WEBPACK FOOTER //
// ./src/views/TradeDetail/components/OrderSearch/OrderSearch.ts